import { PageId } from 'constants/pages'

export const enum PageIdWoofzNrday70 {
  SUBSCRIPTIONS_NRDAY_70_N = PageId.SUBSCRIPTIONS_NRDAY_70_N,
  CHAT_UPSELL_NRDAY_70 = PageId.CHAT_UPSELL_NRDAY_70,
  UPSELL_NRDAY_70 = PageId.UPSELL_NRDAY_70,
  DOWNLOAD_NRDAY_70 = PageId.DOWNLOAD_NRDAY_70,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
